import { render, staticRenderFns } from "./no-forms.vue?vue&type=template&id=42cdc27a&scoped=true&"
import script from "./no-forms.vue?vue&type=script&lang=js&"
export * from "./no-forms.vue?vue&type=script&lang=js&"
import style0 from "./no-forms.vue?vue&type=style&index=0&id=42cdc27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cdc27a",
  null
  
)

export default component.exports